import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useToast } from "../../context/ToastContext";
import AreaApi from "../../services/AreaApi";

// Design System
import Input from "../../components/Input/Input";
import FormCard from "../../components/FormCard/FormCard";

const AreaDetails: React.FC = () => {
  const { t: translateForm } = useTranslation("form");
  const { t: translateGeneral } = useTranslation("general");
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { displayToast } = useToast();

  const [name, setName] = useState<string>("");
  const [unitLabel, setUnitLabel] = useState<string>("");
  const [plantLabel, setPlantLabel] = useState<string>("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!id) {
      navigate("/areas");
      return;
    }

    const fetchArea = async (areaId: string): Promise<void> => {
      try {
        const resp = await AreaApi.GetAreaById(areaId);
        if (resp.success && resp.data) {
          const area = resp.data;
          setName(area.name || "");
          setUnitLabel(area.productionUnit?.name || area.productionUnitName || "—");
          setPlantLabel(area.productionUnit?.plant?.name || area.plantName || "—");
        }
      } catch (err: any) {
        displayToast("error", translateForm("error"), err.message || "", false, 3000);
        navigate("/areas");
      } finally {
        setIsLoading(false);
      }
    };

    fetchArea(id);
  }, [id, navigate, displayToast, translateForm]);

  const handleBack = (): void => {
    navigate("/areas");
  };

  if (isLoading) {
    return <div className="p-4">{translateGeneral("loading")}...</div>;
  }

  return (
    <FormCard
      title={translateForm("areaDetails")}
      icon="info"
      onSubmit={() => {}}
      onCancel={handleBack}
      cancelButtonLabel={translateForm("back") || "Voltar"}
      numColumns={12}
      disabled
    >
      {/* Planta */}
      <div style={{ gridColumn: "span 4" }}>
        <Input
          type="text"
          label={translateForm("plant") || "Planta"}
          value={plantLabel}
          onChange={() => {}}
          disabled
        />
      </div>
      
      {/* Unidade de Produção */}
      <div style={{ gridColumn: "span 4" }}>
        <Input
          type="text"
          label={translateForm("productionUnit") || "Unidade de Produção"}
          value={unitLabel}
          onChange={() => {}}
          disabled
        />
      </div>

      {/* Nome da Área */}
      <div style={{ gridColumn: "span 4" }}>
        <Input
          type="text"
          label={translateForm("name") || "Nome da Área"}
          value={name}
          onChange={() => {}}
          disabled
        />
      </div>
    </FormCard>
  );
};

export default AreaDetails;
